/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedPatientHistoryFormTypesQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedPatientHistoryFormTypesQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    program?: { __typename?: 'Program'; patientHistoryTypes?: Array<string> | null } | null
  }
}

export const GetAdvancedPatientHistoryFormTypesDocument = gql`
  query getAdvancedPatientHistoryFormTypes($uid: ID!) {
    patient(uid: $uid) {
      program {
        patientHistoryTypes(uid: $uid)
      }
    }
  }
`

/**
 * __useGetAdvancedPatientHistoryFormTypesQuery__
 *
 * To run a query within a React component, call `useGetAdvancedPatientHistoryFormTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedPatientHistoryFormTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedPatientHistoryFormTypesQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedPatientHistoryFormTypesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedPatientHistoryFormTypesQuery,
    GetAdvancedPatientHistoryFormTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedPatientHistoryFormTypesQuery, GetAdvancedPatientHistoryFormTypesQueryVariables>(
    GetAdvancedPatientHistoryFormTypesDocument,
    options
  )
}
export function useGetAdvancedPatientHistoryFormTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedPatientHistoryFormTypesQuery,
    GetAdvancedPatientHistoryFormTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedPatientHistoryFormTypesQuery, GetAdvancedPatientHistoryFormTypesQueryVariables>(
    GetAdvancedPatientHistoryFormTypesDocument,
    options
  )
}
export type GetAdvancedPatientHistoryFormTypesQueryHookResult = ReturnType<
  typeof useGetAdvancedPatientHistoryFormTypesQuery
>
export type GetAdvancedPatientHistoryFormTypesLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedPatientHistoryFormTypesLazyQuery
>
export type GetAdvancedPatientHistoryFormTypesQueryResult = Apollo.QueryResult<
  GetAdvancedPatientHistoryFormTypesQuery,
  GetAdvancedPatientHistoryFormTypesQueryVariables
>
